var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('crud-layout-search',{ref:"crudLayoutSearch",attrs:{"params":_vm.params,"interface":_vm.nmInterface,"id":_vm.id,"row-buttons":true,"multiselect":"","name":_vm.name}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }